import { get } from './../utils/api';

export type CategoryModel = {
  key: string | null;
  value: string;
};

// data response
export type CategoryModelResponse = {
  data: Array<CategoryModel>;
  message: string;
  isSuccess: boolean;
};

export interface IListCategoryServices {
  getListCategory(
    keyword?: string,
    parentCateId?: string | null,
    CateId?: string | null,
    type?: number,
  ): Promise<CategoryModelResponse>;
}

export function createListCategoryServices(): IListCategoryServices {
  return {
    getListCategory: async (
      keyword?: string,
      parentCateId?: string,
      CateId?: string | null,
      type?: number,
    ): Promise<CategoryModelResponse> => {
      return (
        await get(
          `MasterData/Common/list-category?${keyword && `Keyword=${keyword}&`}${type && `Type=${type}&`}${
            parentCateId ? `ParentCateId=${parentCateId}&` : ''
          }${CateId ? `CateId=${CateId}` : ''}`,
        )
      ).data;
    },
  };
}
